module.exports = __webpack_public_path__ + "assets/img/mark_red.e01c9d9a.svg";